export default {
    methods: {
        checkPercentage() {
            const percentage = parseFloat(`${this.value.percentage[0]}.${this.value.percentage[1]}`);

            if (percentage > 100) {
                this.$emit('resetPercentageDecimal');
            }
        },

        resetPercentageDecimal() {
            this.leave.percentage = [100, 0];
        },
    },
}
